/**
 * Single source of truth for the production base-URL default — shared by the
 * runtime SEO meta (`meta.ts` → baked into the HTML at prerender) and the
 * build-time sitemap generator (`scripts/gen-sitemap.mjs`). Keeping the default
 * in ONE place means the G1 prod-domain cutover flips the HTML canonical/hreflang
 * AND the sitemap from a single `VITE_SITE_URL` env — never a code change in two
 * spots that could drift (A5/G1).
 *
 * NFR10 — pure constant, zero imports/runtime: `tsc -b` (the composite node
 * project, see tsconfig.node.json) emits `site-url.js` next to this file so the
 * plain-Node sitemap script can import it, exactly like `i18n/locales.ts`.
 *
 * Default = where the NEW site lives today (Railway) — deliberately NOT
 * `done-it.app`, which still serves the OLD site (A5).
 */
export const DEFAULT_SITE_URL = "https://doneit-design-production.up.railway.app";

/**
 * True only once the G1 prod-domain cutover has happened — i.e. `VITE_SITE_URL` was
 * set to a REAL domain different from the staging default. While false (the Railway
 * staging URL), the site MUST be noindex: it carries machine-translated, not-yet
 * native/legal-reviewed copy, and that must never be indexed on the staging URL.
 * One lever (`VITE_SITE_URL`) flips the domain AND indexability together, so the
 * site goes public exactly when the real domain does — never before.
 */
export const isPublicSite = (siteUrl: string): boolean =>
  siteUrl.replace(/\/$/, "") !== DEFAULT_SITE_URL;
